module.exports = __webpack_public_path__ + "static/cryptocurrency-9bc1244dd649a7e03dd827df0eadb87f.svg";